import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createDesignation } from "../../redux/actions/designationActions";

const CreateDesignation = () => {
  const [name, setName] = useState("");

  const dispatch = useDispatch();
  const { creating, error } = useSelector((state) => state.designation);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    dispatch(createDesignation({ name }));
    setName("");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Designation</h1>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-gray-700 font-medium mb-1">Designation Name</label>
            <input
              type="text"
              placeholder="Enter designation name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
              required
            />
          </div>

          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
              creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Creating..." : "Create Designation"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateDesignation;
